import { Banner } from 'breadcrumbs-ui/components/Banner';
import { Text } from 'breadcrumbs-ui/components/Text';
import { useEffect, useState } from 'react';
import { getSandboxSelfData } from '../api/cachedFetchers';
import { SANDBOX_BANNER_ID, SANDBOX_TYPE, SANDBOX_VERSION } from '../constants/constants';
import { KBLink } from './KBLink';
import { SetUpDeployLink } from './SetUpDeployLink';
import { useTranslation } from '../../../hooks/useNavConfig';
import { simpleErrorHandler } from '../../../errors/simpleErrorHandler';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SandboxBanner() {
  const {
    t
  } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [sandboxSelfData, setSandboxSelfData] = useState(null);
  const {
    type,
    version,
    parentHubId
  } = sandboxSelfData || {};
  const deployingEnabled = type === SANDBOX_TYPE.STANDARD && version === SANDBOX_VERSION.V2;
  useEffect(() => {
    getSandboxSelfData().then(sandboxData => {
      setSandboxSelfData(sandboxData);
      setIsLoading(false);
    }).catch(simpleErrorHandler('Failed to get sandbox self data'));
  }, []);
  return /*#__PURE__*/_jsx(Banner, {
    id: SANDBOX_BANNER_ID,
    isLoading: isLoading,
    title: /*#__PURE__*/_jsx(Text, {
      typography: "heading-25",
      color: "text-core-default",
      children: type === SANDBOX_TYPE.DEVELOPER ? t('nav.sandboxBanner.developmentSandbox') : type === SANDBOX_TYPE.STANDARD ? t('nav.sandboxBanner.standardSandbox') : t('nav.sandboxBanner.sandbox')
    }),
    actions: deployingEnabled && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(KBLink, {}), /*#__PURE__*/_jsx(SetUpDeployLink, {
        parentHubId: parentHubId !== null && parentHubId !== void 0 ? parentHubId : null
      })]
    })
  });
}